import { computed } from 'vue';
import { featureFlagService } from '@/models/feature-flag';
function newInvoiceFilterEnabled() {
    return featureFlagService.can('new-invoice-filter-modal');
}
export function useNewInvoiceFilter() {
    return computed(newInvoiceFilterEnabled);
}
// build a route link to a filtered index for a set of filter clauses. with the new filter
// modal on, filters ride history state (the target page's filter seeding reads them)
// instead of the URL query — so the list stops depending on ?query for filtering.
// legacyQuery is the fallback used while the flag is off.
//
// only for targets that have adopted the v2 surface: a page still reading ?query would
// silently drop a state-borne filter and show an unfiltered list.
export function filteredIndexLink(name, clauses, legacyQuery) {
    if (newInvoiceFilterEnabled()) {
        return { name, state: { filters: clauses } };
    }
    return { name, query: legacyQuery };
}
export function invoiceIndexLink(clauses, legacyQuery) {
    return filteredIndexLink('invoice.index', clauses, legacyQuery);
}
export function clientIndexLink(clauses, legacyQuery) {
    return filteredIndexLink('client.index', clauses, legacyQuery);
}
export function workActIndexLink(clauses, legacyQuery) {
    return filteredIndexLink('work-act.index', clauses, legacyQuery);
}
export function commercialSuggestionIndexLink(clauses, legacyQuery) {
    return filteredIndexLink('commercial-suggestion.index', clauses, legacyQuery);
}
export function productIndexLink(clauses, legacyQuery) {
    return filteredIndexLink('product.index', clauses, legacyQuery);
}
// Expenses exist as two modules with separate lists, so every link into "the expense list"
// has to resolve which one the company is on.
export function expenseIndexRouteName() {
    return featureFlagService.can('expense-new') ? 'expense-new.index' : 'expense.index';
}
export function useExpenseIndexRouteName() {
    return computed(expenseIndexRouteName);
}
// Only the new expense list has adopted the v2 surface — the legacy one filters from ?query
// alone and would drop a state-borne clause, so clauses travel only when it is the target.
export function expenseIndexLink(clauses, legacyQuery) {
    if (!featureFlagService.can('expense-new')) {
        return { name: 'expense.index', query: legacyQuery };
    }
    return filteredIndexLink('expense-new.index', clauses, legacyQuery);
}
// reactive variant for a single static link (dashboard-style). for per-row / dynamic
//  links, call invoiceIndexLink() directly in the template instead.
export function useInvoiceIndexLink(clauses, legacyQuery) {
    return computed(() => invoiceIndexLink(clauses, legacyQuery));
}
